export default {
  steps: {
    setup_fee: 'Costo di configurazione',
    business_info: 'Dati aziendali',
    create_preview: 'Crea contratto di anteprima',
    preview: 'Anteprima contratto',
    sign: 'Firma contratto',
  },
  buttons: {
    next: 'Anteprima contratto',
    save_and_continue: 'Salva e continua',
    update: 'Aggiorna anteprima',
    cancel: 'Annulla corrente',
    skip: 'Salta creazione contratto',
  },
  create_preview: {
    header: 'Crea contratto di anteprima',
    description: "Inserisci i dati del destinatario per il contratto. Puoi ancora modificarli prima dell'invio.",
  },
  sign: {
    update_notice: 'Per aggiornare il contratto, annulla quello attuale e modifica i dettagli.',
  },
  toasts: {
    failed_to_save_changes: 'Impossibile salvare le modifiche',
  },
};
